import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import { reducer as oidc } from "redux-oidc";
import userReducer from "../services/oidc/reducer/userReducer";
import notifications from "./notificationsReducer";
import redirect from "./redirectReducer";
import nationalities from "./nationalitiesReducer";
import organizations from "./organizationsReducer";
import countries from "./countriesReducer";
import watchLists from "./watchListsReducer";
import {
  watchListEntries,
  watchListEntriesByWatchList,
  uploadCsvCustomWatchlist,
  createWatchListEntry,
  updateWatchListEntry,
  watchListMultipleSearchEntries,
} from "../features/watch-list-entry/reducers";
import logs from "../features/log/reducers/logsReducer";
import {
  monitoringQueueEntries,
  monitoringQueueEntryDetails,
  getScoreCardsByType,
  getScoringDecisionTemplate,
} from "../features/monitoring-queue-entry/reducers";
import watchListEntriesHighRiskCountry from "../features/watch-list-entry-high-risk-country/reducers/watchListEntriesReducer";
import createHighRiskCountry from "../features/watch-list-entry-high-risk-country/reducers/createHighRiskCountryReducer";
import userActivity from "./userActivityReducer";
import csvClients from "../features/score-card/reducers/csvClientsReducer";
import scoringLogs from "../features/score-card/reducers/getLastScoringLogsReducer";
import scoreCards from "../features/score-card/reducers/scoreCardsReducer";
import organizationInfo from "../features/organization/reducers/organizationInfoReducer";
import getAsyncJobs from "../features/organization/reducers/getAsyncJobsReducer";
import getEmailNotifications from "../features/organization/reducers/getEmailNotificationsReducer";
import getAllScoreCardsRiskFactorsByType from "../features/score-card/reducers/getAllScoreCardsRiskFactorsByTypeReducer";
import {
  createWatchListEntryEuTerrorist,
  updateWatchListEntryEuTerrorist,
} from "../features/watch-list-entry-eu-terrorists/reducers";
import scoreCardCalculate from "../features/score-card/reducers/scoreCardCalculateReducer";
//Client Profile
import {
  clientProfileEntries,
  clientProfileEntryDetails,
  changeClientProfileEntryStatus,
} from "../features/client-profile/reducers";

//Reports
import {
  watchListUpdateLogs,
  multipleClientsReport,
  singleClientReportEntries,
  singleClientReportDetails,
  exportSingleClientReportPdf,
  exportMultipleClientReportPdf,
  exportMultipleClientReportHtml,
  exportScoringResultsReportCsv,
  scoringResultsReportEntries,
} from "../features/reports/reducers";
import exportLogsCsv from "../features/log/reducers/exportLogsReducer";
import getOfferIds from "../features/score-card/reducers/getOfferIdsReducer";
import changeDecisionModalsReducer from "../features/monitoring-queue-entry/reducers/changeDecisionModalReducer";
import exportClientProfilePdf from "../features/client-profile/reducers/exportClientProfilePdfReducer";

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    notifications,
    nationalities,
    countries,
    watchLists,
    watchListEntriesByWatchList,
    watchListEntries,
    uploadCsvCustomWatchlist,
    logs,
    monitoringQueueEntries,
    clientProfileEntries,
    clientProfileEntryDetails,
    changeClientProfileEntryStatus,
    monitoringQueueEntryDetails,
    watchListEntriesHighRiskCountry,
    createHighRiskCountry,
    scoringLogs,
    oidc,
    userReducer,
    organizations,
    userActivity,
    scoreCards,
    organizationInfo,
    getAsyncJobs,
    getEmailNotifications,
    csvClients,
    redirect,
    watchListUpdateLogs,
    singleClientReportEntries,
    singleClientReportDetails,
    exportSingleClientReportPdf,
    exportMultipleClientReportPdf,
    exportMultipleClientReportHtml,
    multipleClientsReport,
    scoringResultsReportEntries,
    exportScoringResultsReportCsv,
    getScoreCardsByType,
    createWatchListEntry,
    updateWatchListEntry,
    createWatchListEntryEuTerrorist,
    updateWatchListEntryEuTerrorist,
    watchListMultipleSearchEntries,
    getAllScoreCardsRiskFactorsByType,
    scoreCardCalculate,
    exportLogsCsv,
    getScoringDecisionTemplate,
    getOfferIds,
    changeDecisionModalsReducer,
    exportClientProfilePdf,
  });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js